"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _redux = require("redux");
var _reactRedux = require("react-redux");
var _awsAmplify = require("aws-amplify");
var _helpers = require("../helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const mapStateToProps = (state, props) => {
  return {
    [props.entity.plural]: state[props.entity.plural]
  };
};
const mapDispatchToProps = (dispatch, props) => {
  return {
    create: (0, _redux.bindActionCreators)(props.actions.create, dispatch)
  };
};
class BaseCreate extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      [this.props.entity.singular]: (0, _helpers.mapSchemaToState)(this.props[this.props.entity.plural].create.schema),
      fetching: false // TODO: fetching to redux?
    });
    _defineProperty(this, "handleChange", body => {
      const {
        singular
      } = this.props.entity;
      return new Promise(resolve => {
        this.setState({
          [singular]: {
            ...this.state[singular],
            ...body
          }
        }, () => resolve());
      });
    });
    _defineProperty(this, "handleSubmit", event => {
      event.preventDefault();
      const {
        entity,
        history,
        create,
        [this.props.entity.plural]: store
      } = this.props;
      const onSubmitSuccess = store.create && store.create.form && store.create.form.onSubmitSuccess ? store.create.form.onSubmitSuccess : undefined;
      this.setState({
        fetching: true
      });
      _awsAmplify.Auth.currentSession().then(data => {
        create(this.state[entity.singular], store.expand, data.idToken.jwtToken) // {expand: store.expand}
        .then(response => {
          this.setState({
            fetching: false
          });
          onSubmitSuccess ? onSubmitSuccess(this.props) : history.push(`/${entity.plural}/${response.Id}`);
        }).catch(error => this.setState({
          fetching: false,
          error
        }));
      }).catch(err => console.log("Error: " + err));
    });
    _defineProperty(this, "render", () => {
      const {
        children,
        entity,
        [this.props.entity.plural]: store,
        ...rest
      } = this.props;
      if (!store.schema) console.error(`There is no schema for creating ${entity.singular}`);
      return _react.default.cloneElement(children, {
        ...rest,
        state: this.state[entity.singular],
        error: this.state.error,
        fetching: this.state.fetching,
        schema: store.create.schema,
        onChange: this.handleChange,
        onSubmit: this.handleSubmit
      });
    });
  }
}
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BaseCreate);
module.exports = exports.default;